import ApiClient from './ApiClient';

class ClusterTypesAPI extends ApiClient {
  constructor() {
    super('cluster_types', { accountScoped: true });
  }
}

export default new ClusterTypesAPI();
